import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';

import InOutResultContext from '../../services/inOutResult/InOutResultContext';
import Tippy, { ToolTip } from '../../components/ReactTippy';

import { Confirmation } from '../modals/common/';
import { OnOffRadioButton } from '../radiobutton/OnOffRadioButton';
import { SelectHour } from '../select/SelectHour';
import { SelectMin } from '../select/SelectMin';
import { SelectBox } from '../select/SelectBox';
import RequireIcon from '../../components/RequireIcon';
import InOutResultDropdownSelector from '../../components/dropdowns/single/InOutResult';
import SessionStorageService from '../../services/utilities/SessionStorageService';
import FieldSpotWorkersApi from '../../services/fieldSpotWorkers/FieldSpotWorkersApi';
import { Description } from '../Description';

import { isPartnerCompanyRoleId } from '../../utilities/roleUtility';
import {
  isNullOrEmpty,
  isNullOrUndefinedOrEmptyStr,
} from '../../utilities/stringUtil';
import {
  APPROVED_STATUS,
  CCUS_SENT_STATUS,
  DATE_TIME_FORMAT,
  DIALOG_STATUS,
  RECORDING_METHOD,
  SORT_TYPE,
  MANUAL_BODY_TEMPERATURE,
  ENTRANCE_WORKER_TYPES,
  API_FLAG,
} from '../../utilities/constants';
import { messageUtility } from '../../utilities/messageUtility';
import { isIPad } from '../../utilities/commonUtil';

import Styles from '../../styles/componentStyle/inOutResult/inOutResult.scss';
import { RadioButtonIcon } from '../icons/RadioButtonIcon';

/**
 * 入退場実績データテーブル
 * */
export const TableLayout = () => {
  // 画面表示
  return (
    <InOutResultContext.Consumer>
      {({ state, closeEditDialog, updateCheckInOutResult, changeSort }) => (
        <div className={`${Styles.table} master-slide-view__body`}>
          {state.ccusSecededWarning && (
            <Description type='primary'>
              <span className='text--negative'>
                {messageUtility.getMessage(
                  state.jvFlag ? 'I-002-013-01' : 'I-002-013-05'
                )}
              </span>
            </Description>
          )}
          <table className='table'>
            <thead className='table__header'>
              <tr className='table__label'>
                <th className='value-table value-table--table__label' />
                {data.tableTitles
                  .filter(
                    title =>
                      (!title.name.startsWith('body_temperature') &&
                        !title.name.startsWith('worker_type') &&
                        !title.name.startsWith(
                          'check_in_out_field_area_name'
                        )) ||
                      (title.name == 'body_temperature_tag' &&
                        state.manualBodyTemperatureExists == 1) ||
                      (title.name == 'body_temperature' &&
                        state.bodyTemperatureExists == 1) ||
                      (title.name == 'worker_type' && state.spotFlg) ||
                      (title.name == 'check_in_out_field_area_name' &&
                        SessionStorageService.getUseWorkerEntranceAppFlg() ==
                          1)
                  )
                  .map((title, index) => (
                    <th
                      className={`value-table value-table--table__label ${title.name}`}
                      key={index}
                      onClick={() => {
                        if (title.skipSort !== true) {
                          changeSort(title.name);
                        }
                      }}
                    >
                      <div className={`value-table__label`}>
                        <span
                          className={`${
                            title.skipSort === true
                              ? 'value-table__label-no-sort-icon'
                              : 'value-table__label-with-sort-icon'
                          }`}
                        >
                          {title.label}
                          {state.searchForm.order === title.name &&
                            state.searchForm.sortType === SORT_TYPE.asc.id && (
                              <button className='btn-icon--xs--dark btn-icon__sort '>
                                <i className='i-sortaz i-1x' />
                              </button>
                            )}
                          {state.searchForm.order === title.name &&
                            state.searchForm.sortType === SORT_TYPE.desc.id && (
                              <button className='btn-icon--xs--dark btn-icon__sort '>
                                <i className='i-sortza i-1x' />
                              </button>
                            )}
                          {title.skipSort !== true &&
                            state.searchForm.order !== title.name && (
                              <button className='btn-icon--xs--dark btn-icon__sort btn-icon__sort--low-opacity'>
                                <i className='i-sortdefault i-1x' />
                              </button>
                            )}
                        </span>
                      </div>
                    </th>
                  ))}
              </tr>
            </thead>
            <tbody className='table__body'>
              {state.checkInOutLogList.map((item, index) => {
                return (
                  <FixItems
                    bodyTemperatureExists={state.bodyTemperatureExists}
                    manualBodyTemperatureExists={
                      state.manualBodyTemperatureExists
                    }
                    inOutResult={item}
                    priorCcusError={state.searchForm.priorCcusError}
                    key={index}
                  />
                );
              })}
            </tbody>
          </table>

          <Confirmation
            visible={state.dialogStatus === DIALOG_STATUS.editDialogEnabled.id}
            title={data.editDialog.title}
            cancelButtonText={data.editDialog.back}
            confirmButtonText={data.editDialog.edit}
            message={<AssignDialogMessage />}
            isNegative={true}
            onCancel={() => closeEditDialog()}
            onConfirm={() => updateCheckInOutResult()}
            disabledConfirmButton={state.editForm.isValid !== true}
            rootClassName={Styles.editDialog}
            negativeButtonClassName={
              state.editForm.isValid !== true ? 'btn-disable' : 'btn--effective'
            }
          />
        </div>
      )}
    </InOutResultContext.Consumer>
  );
};

/**
 * 入退場実績データ表示
 * */
const FixItems = ({
  bodyTemperatureExists,
  manualBodyTemperatureExists,
  inOutResult,
  priorCcusError,
}) => {
  let trClassName = 'table__item enable';
  if (inOutResult.approved_flg === APPROVED_STATUS.unapproved.id) {
    trClassName = 'unapproved-item table__item enable';
  } else if (
    inOutResult.ccus_send_status === CCUS_SENT_STATUS.sendingError.id &&
    priorCcusError
  ) {
    trClassName = 'failed-item table__item enable';
  }

  const workerTypeKey = Object.keys(ENTRANCE_WORKER_TYPES).find(
    worker_type =>
      ENTRANCE_WORKER_TYPES[worker_type].id === inOutResult.worker_type
  );

  const workerTypeName = !_.isNil(workerTypeKey)
    ? ENTRANCE_WORKER_TYPES[workerTypeKey].name
    : '';

  // 画面表示
  return (
    <InOutResultContext.Consumer>
      {({ state, showEditDialog, checkSingleTableData }) => (
        <tr className={trClassName} onClick={() => showEditDialog(inOutResult)}>
          <td
            className='gate-list-value-table__name'
            onClick={event => event.stopPropagation()}
          >
            <label className='toggle-radius'>
              <input
                type='checkbox'
                name='single-checkbox'
                value={inOutResult.id}
                disabled={isPartnerCompanyRoleId(state.roleId)}
                checked={
                  _.includes(
                    state.selectedApproveCheckInOutLogList,
                    inOutResult
                  ) ||
                  _.includes(
                    state.selectedUnapprovedCheckInOutLogList,
                    inOutResult
                  )
                }
                onChange={() => {
                  checkSingleTableData(inOutResult);
                }}
              />
              <i className='i-square i-3x' aria-hidden='true' />
            </label>
          </td>
          <td className='gate-list-value-table__name approved'>
            {_.map(APPROVED_STATUS, item => {
              if (inOutResult.approved_flg === item.id) {
                return <p key={item.id}>{item.name}</p>;
              }
            })}
          </td>
          {state.spotFlg && (
            <td className='gate-list-value-table__name worker_type'>
              <p>{workerTypeName}</p>
            </td>
          )}
          <td className='gate-list-value-table__name company_name_1'>
            <div className='company_name_1__content'>
              {inOutResult.partner_ccus_seceded_warning &&
                !state.ccusSecededWarning &&
                (isIPad() ? (
                  <i className='icon-warning_round' />
                ) : (
                  <Tippy
                    duration={10}
                    distance={24}
                    delay={[50, 100]}
                    placement='bottom'
                    followCursor={true}
                    html={
                      <ToolTip tooltipStyle={{ whiteSpace: 'pre-wrap' }}>
                        {messageUtility.getMessage('I-002-013-03')}
                      </ToolTip>
                    }
                  >
                    <i className='icon-warning_round' />
                  </Tippy>
                ))}
              <WithTooltip>
                <React.Fragment>
                  {(inOutResult.worker_type ===
                    ENTRANCE_WORKER_TYPES.worker.id &&
                    inOutResult.company_name_1) ||
                    (inOutResult.worker_type ===
                      ENTRANCE_WORKER_TYPES.guest.id &&
                      inOutResult.spot_company_name) ||
                    inOutResult.company_name}
                  {inOutResult.worker_type ===
                    ENTRANCE_WORKER_TYPES.worker.id && (
                    <React.Fragment>
                      <br />({inOutResult.company_name})
                    </React.Fragment>
                  )}
                </React.Fragment>
              </WithTooltip>
            </div>
          </td>
          <td className='gate-list-value-table__name worker_name value-table__worker-name'>
            <WithTooltip>
              <span>
                <span className='fullname-kana'>
                  {inOutResult.worker_name_kana}
                </span>{' '}
                <br />
                <span className='name-kanji'>{inOutResult.worker_name}</span>
              </span>
            </WithTooltip>
          </td>
          <td className='gate-list-value-table__name target_date'>
            <p>
              {moment(new Date(inOutResult.target_date).toISOString()).format(
                DATE_TIME_FORMAT.slashDateFormat
              )}
            </p>
          </td>
          <td className='gate-list-value-table__name in'>
            <p>
              {!isNullOrEmpty(inOutResult.in_hour) &&
                !isNullOrEmpty(inOutResult.in_min) &&
                moment(
                  new Date(
                    data.date.year,
                    data.date.month,
                    data.date.day,
                    Number(inOutResult.in_hour),
                    Number(inOutResult.in_min),
                    Number(inOutResult.in_sec)
                  ).toISOString()
                ).format(DATE_TIME_FORMAT.timeFormat)}
            </p>
          </td>
          <td className='gate-list-value-table__name out'>
            <p>
              {!isNullOrEmpty(inOutResult.out_hour) &&
                !isNullOrEmpty(inOutResult.out_min) &&
                moment(
                  new Date(
                    data.date.year,
                    data.date.month,
                    data.date.day,
                    Number(inOutResult.out_hour),
                    Number(inOutResult.out_min),
                    Number(inOutResult.out_sec)
                  ).toISOString()
                ).format(DATE_TIME_FORMAT.timeFormat)}
            </p>
          </td>
          {manualBodyTemperatureExists == 1 && (
            <td className='gate-list-value-table__name body_temperature_tag'>
              {!isNullOrEmpty(inOutResult.manual_body_temperature) && (
                <p>{data.manualBodyTemperatureTag}</p>
              )}
              {!isNullOrEmpty(inOutResult.body_temperature) && <br />}
            </td>
          )}
          {bodyTemperatureExists == 1 && (
            <td className='gate-list-value-table__name body_temperature'>
              {!isNullOrEmpty(inOutResult.manual_body_temperature) && (
                <p>{inOutResult.manual_body_temperature}</p>
              )}
              <p>{inOutResult.body_temperature}</p>
            </td>
          )}
          <td className='gate-list-value-table__name ccus_send_status'>
            {_.map(CCUS_SENT_STATUS, item => {
              let itemName = item.name;
              if (inOutResult.ccus_send_status === item.id) {
                // BLDE_V2-50226 CCUS事業者ID削除されたならステータスを変更する
                if (
                  inOutResult.ccus_send_status === CCUS_SENT_STATUS.unsent.id &&
                  inOutResult.ccus_jigyousya_deleted_flag === API_FLAG.On
                ) {
                  itemName = CCUS_SENT_STATUS.unableToSend.name;
                } else if (
                  inOutResult.ccus_send_status ==
                    CCUS_SENT_STATUS.notSentAfterChange.id &&
                  inOutResult.ccus_jigyousya_deleted_flag === API_FLAG.On
                ) {
                  itemName = CCUS_SENT_STATUS.unableToSendAfterChange.name;
                }
                const content = <p key={item.id}>{itemName}</p>;
                // iPadの場合、ホバーできないためツールチップを表示させない BLDE_V2-46523
                // BLDE_V2-50226 CCUS事業者IDは削除のステータスの場合にもツールチップは表示される
                if (
                  (inOutResult.ccus_send_status == CCUS_SENT_STATUS.exempt.id ||
                    (inOutResult.ccus_send_status ==
                      CCUS_SENT_STATUS.notSentAfterChange.id &&
                      inOutResult.ccus_jigyousya_deleted_flag ===
                        API_FLAG.On) ||
                    (inOutResult.ccus_send_status ===
                      CCUS_SENT_STATUS.unsent.id &&
                      inOutResult.ccus_jigyousya_deleted_flag ===
                        API_FLAG.On)) &&
                  !isIPad()
                ) {
                  return (
                    <Tippy
                      duration={10}
                      distance={24}
                      arrowType='sharp'
                      delay={[100, 0]}
                      placement='bottom'
                      followCursor={true}
                      html={
                        <div className={Styles.toopTip}>
                          {inOutResult.ccus_untargeted_reason}
                        </div>
                      }
                    >
                      {content}
                    </Tippy>
                  );
                } else {
                  return content;
                }
              }
            })}
          </td>
          <td className='gate-list-value-table__name remarks'>
            <WithTooltip>{inOutResult.remarks}</WithTooltip>
          </td>
          <td className='gate-list-value-table__name job_category'>
            {isNullOrUndefinedOrEmptyStr(
              inOutResult.job_category_major_name
            ) === false &&
              isNullOrUndefinedOrEmptyStr(
                inOutResult.job_category_minor_name
              ) === false && (
                <React.Fragment>
                  <div className='job-category'>
                    <span>{data.jobCategoryLabel.large}</span>
                    {inOutResult.job_category_major_name}
                  </div>
                  <div className='job-category'>
                    <span>{data.jobCategoryLabel.small}</span>
                    {inOutResult.job_category_minor_name}
                  </div>
                </React.Fragment>
              )}
          </td>
          <td className='gate-list-value-table__name position_code'>
            <WithTooltip>{inOutResult.position_name}</WithTooltip>
          </td>

          {SessionStorageService.getUseWorkerEntranceAppFlg() == 1 && (
            <td className='gate-list-value-table__name check_in_out_field_area_name'>
              <WithTooltip>
                {inOutResult.check_in_out_field_area_name}
              </WithTooltip>
            </td>
          )}
          <td className='gate-list-value-table__name check_in_out_record_type_name'>
            {isNullOrUndefinedOrEmptyStr(
              inOutResult.check_in_record_type_name
            ) === false && (
              <React.Fragment>
                <div className='record-type-category'>
                  <span>{data.checkInOutRecordTypeLabel.in}</span>
                  {inOutResult.check_in_record_type_name}
                </div>
              </React.Fragment>
            )}
            {isNullOrUndefinedOrEmptyStr(
              inOutResult.check_out_record_type_name
            ) === false && (
              <React.Fragment>
                <div className='record-type-category'>
                  <span>{data.checkInOutRecordTypeLabel.out}</span>
                  {inOutResult.check_out_record_type_name}
                </div>
              </React.Fragment>
            )}
          </td>
        </tr>
      )}
    </InOutResultContext.Consumer>
  );
};

/**
 * 入退場実績更新用のダイアログ
 * */
const AssignDialogMessage = () => {
  // 画面表示
  return (
    <InOutResultContext.Consumer>
      {({
        state,
        toggle,
        setTime,
        showSelectWorkerDialog,
        setManualBodyTemperature,
        setRemarks,
        onChangeWorkerType,
        selectedWorker,
      }) => (
        <React.Fragment>
          <ul className='form-list form-list-default'>
            {state.spotFlg && (
              <li className='form-list__item'>
                <div className='worker-type__label'>
                  <span className='label'>
                    {data.editDialog.workerType}
                    <RequireIcon />
                  </span>
                </div>
                <div className='worker-type__element'>
                  <div className='form-list-radio disabled'>
                    <div className='form-list-radio__item'>
                      <label className='radio'>
                        <input
                          type='radio'
                          name='worker_type'
                          disabled='true'
                          value={ENTRANCE_WORKER_TYPES.worker.id}
                          checked={
                            parseInt(state.editForm.workerType) ===
                            ENTRANCE_WORKER_TYPES.worker.id
                          }
                          onChange={event =>
                            onChangeWorkerType(event.target.value)
                          }
                        />
                        <RadioButtonIcon className='icon--2x' />
                        <span>{ENTRANCE_WORKER_TYPES.worker.name}</span>
                      </label>
                    </div>
                    <div className='form-list-radio__item'>
                      <label className='radio'>
                        <input
                          type='radio'
                          name='worker_type'
                          disabled='true'
                          value={ENTRANCE_WORKER_TYPES.permanent.id}
                          checked={
                            parseInt(state.editForm.workerType) ===
                            ENTRANCE_WORKER_TYPES.permanent.id
                          }
                          onChange={event =>
                            onChangeWorkerType(event.target.value)
                          }
                        />
                        <RadioButtonIcon className='icon--2x' />
                        <span>現場{ENTRANCE_WORKER_TYPES.permanent.name}</span>
                      </label>
                    </div>
                    <div className='form-list-radio__item'>
                      <label className='radio'>
                        <input
                          type='radio'
                          name='worker_type'
                          disabled='true'
                          value={ENTRANCE_WORKER_TYPES.guest.id}
                          checked={
                            parseInt(state.editForm.workerType) ===
                              ENTRANCE_WORKER_TYPES.temporary.id ||
                            parseInt(state.editForm.workerType) ===
                              ENTRANCE_WORKER_TYPES.guest.id
                          }
                          onChange={event =>
                            onChangeWorkerType(event.target.value)
                          }
                        />
                        <RadioButtonIcon className='icon--2x' />
                        <span>
                          {ENTRANCE_WORKER_TYPES.temporary.name}・
                          {ENTRANCE_WORKER_TYPES.guest.name}
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </li>
            )}
            <li className='form-list__item'>
              <div className='worker-name__label'>
                <span className='label'>{data.editDialog.workerName}</span>
              </div>
              <div className='worker-name__element'>
                {(state.editForm.workerType ===
                  ENTRANCE_WORKER_TYPES.worker.id && (
                  <React.Fragment>
                    <span>{state.editForm.workerName}</span>
                    <button
                      className='btn--sub'
                      onClick={() => showSelectWorkerDialog()}
                    >
                      {data.buttonTitle.worker_search}
                    </button>
                  </React.Fragment>
                )) || (
                  <InOutResultDropdownSelector
                    hasTooltipAllSelect={false}
                    multiple={false}
                    api={params =>
                      FieldSpotWorkersApi.fetchFieldSpotWorkersList(
                        SessionStorageService.getFieldId(),
                        params
                      )
                    }
                    clearFlag={state.editFormClearFlag}
                    apiParams={state.apiData}
                    apiSearchKey='spot_worker_name'
                    keyName='fullname'
                    valueName='entrance_worker_id'
                    label='選択してください'
                    selectedValues={
                      state.editForm.workerId ? [state.editForm.workerId] : []
                    }
                    selectedName={state.editForm.workerName}
                    apiProcess={response => {
                      if (_.isNil(response.data.entities)) {
                        return {
                          data: [],
                          total: 0,
                        };
                      }
                      const list = _.map(
                        response.data.entities.field_spot_workers,
                        item => ({
                          entrance_worker_id: item.entrance_worker_id,
                          fullname: item.fullname,
                          spot_company_name: item.spot_company_name,
                          prime_company_name: item.prime_company_name,
                        })
                      );
                      return {
                        data: list,
                        total: list.length,
                      };
                    }}
                    onSelect={values => {
                      selectedWorker(values);
                    }}
                  />
                )}
              </div>
            </li>
            {[
              ENTRANCE_WORKER_TYPES.temporary.id,
              ENTRANCE_WORKER_TYPES.guest.id,
            ].includes(state.editForm.workerType) &&
              (state.editForm.spotCompanyName ||
                state.editForm.primeCompanyName) && (
                <React.Fragment>
                  <li className='form-list__item'>
                    <div className='field-tree__label'>
                      <span className='label'>
                        {data.editDialog.companyName}
                      </span>
                    </div>
                    <div className='field-tree__element'>
                      <p>
                        {(state.editForm.workerType ===
                          ENTRANCE_WORKER_TYPES.guest.id &&
                          state.editForm.spotCompanyName) ||
                          state.editForm.primeCompanyName}
                      </p>
                    </div>
                  </li>
                </React.Fragment>
              )}
            {state.editForm.workerType === ENTRANCE_WORKER_TYPES.worker.id && (
              <li className='form-list__item'>
                <div className='field-tree__label'>
                  <span className='label'>
                    {data.editDialog.fieldTree}
                    {state.apiData.partner_ccus_seceded_warning && (
                      <i
                        className='icon-warning_round'
                        style={{ color: '#e6960e', fontSize: 24 }}
                      />
                    )}
                  </span>
                </div>
                <div className='field-tree__element'>
                  <p>{state.editForm.displayFieldTree}</p>
                  {state.apiData.partner_ccus_seceded_warning && (
                    <Description type='primary'>
                      {messageUtility.getMessage('I-002-013-03')}
                    </Description>
                  )}
                </div>
              </li>
            )}
            {state.editForm.recordingMethod !== '' && (
              <React.Fragment>
                <li className='form-list__item'>
                  <OnOffRadioButton
                    label={data.editDialog.recordingMethod}
                    name='recording_method'
                    onButtonLabel={RECORDING_METHOD.entranceAndExit.name}
                    offButtonLabel={RECORDING_METHOD.onlyAdmission.name}
                    value={state.editForm.recordingMethod}
                    rootClassName='recording-method'
                    onChange={() => toggle('recordingMethod')}
                  />
                </li>
              </React.Fragment>
            )}
            <li className='form-list__item'>
              <div className='attendance-date__label'>
                <span className='label'>{data.editDialog.attendanceDate}</span>
              </div>
              <div className='attendance-date__element'>
                <div className='sys-form-calender'>
                  <div className='dropdown-calender'>
                    <div className='dropdown-calender__input'>
                      <input
                        className='sys-dropdown-trigger sys-name sys-dropdown-trigger--inner-dialog'
                        type='text'
                        name='editForm.targetDate'
                        placeholder={data.placeholder.attendanceDate}
                        value={state.editForm.targetDate}
                        onChange={() => null}
                        autoComplete='off'
                        readOnly
                      />
                      <div className='btn-spin'>
                        <button className='btn-spin__up sys-calender-day-up'>
                          <i className='i_arrow-top' />
                        </button>
                        <button className='btn-spin__down sys-calender-day-down'>
                          <i className='i_arrow-bottom' />
                        </button>
                      </div>
                    </div>
                    <div className='dropdown'>
                      <div className='dropdown-calender__calender' />
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li className='form-list__item'>
              <div className='in-time__label'>
                <span className='label'>{data.editDialog.inTime}</span>
              </div>
              <div className='in-time__element'>
                <SelectHour
                  className='in_hour'
                  name='in_hour'
                  value={state.editForm.inHour}
                  onChange={event => setTime('inHour', event.target.value)}
                />
                <span className='dialog__colon'>{data.dateColon}</span>
                <SelectMin
                  className='in_min'
                  name='in_min'
                  value={state.editForm.inMin}
                  onChange={event => setTime('inMin', event.target.value)}
                />
              </div>
            </li>
            {state.editForm.recordingMethod ===
              RECORDING_METHOD.entranceAndExit.id && (
              <React.Fragment>
                <li className='form-list__item'>
                  <div className='out-time__label'>
                    <span className='label'>{data.editDialog.outTime}</span>
                  </div>
                  <div className='out-time__element'>
                    <SelectHour
                      className='out_hour'
                      name='out_hour'
                      value={state.editForm.outHour}
                      onChange={event => setTime('outHour', event.target.value)}
                    />
                    <span className='dialog__colon'>{data.dateColon}</span>
                    <SelectMin
                      className='out_min'
                      name='out_min'
                      value={state.editForm.outMin}
                      onChange={event => setTime('outMin', event.target.value)}
                    />
                  </div>
                </li>
                <li className='form-list__item'>
                  <div className='next-day__label'>
                    <span className='label'>{data.editDialog.nextDay}</span>
                  </div>
                  <div className='next-day__element'>
                    <input
                      type='checkbox'
                      checked={state.editForm.nextFlg}
                      onChange={() => {
                        toggle('nextFlg');
                      }}
                    />
                  </div>
                </li>
              </React.Fragment>
            )}
            <li className='form-list__item'>
              <div className='body-temperature__label'>
                <span className='label'>{data.editDialog.bodyTemperature}</span>
              </div>
              <div className='body-temperature__element'>
                <span>{state.editForm.bodyTemperature}</span>
              </div>
            </li>
            <li className='form-list__item'>
              <div className='manual-body-temperature__label'>
                <span className='label'>
                  {data.editDialog.manualBodyTemperature}
                </span>
              </div>
              <div className='manual-body-temperature__element'>
                <SelectBox
                  name='manual-body-temperature'
                  value={state.editForm.manualBodyTemperature}
                  isPlaceholderHidden={true}
                  items={MANUAL_BODY_TEMPERATURE}
                  onChange={event => {
                    setManualBodyTemperature(event.target.value);
                  }}
                />
              </div>
            </li>
            <li className='form-list__item'>
              <div className='manual-body-temperature__label'>
                <span className='label'>CCUS送信</span>
              </div>
              <div className='manual-body-temperature__element'>
                {state.apiData.ccus_untargeted_reason
                  ? `${getCcusSentNameById(state.apiData.ccus_send_status)} - ${
                      state.apiData.ccus_untargeted_reason
                    }`
                  : `${getCcusSentNameById(state.apiData.ccus_send_status)}`}
              </div>
            </li>
            <li className='form-list__item'>
              <div className='remarks__label'>
                <span className='label'>{data.editDialog.remarks}</span>
              </div>
              <div className='remarks__element'>
                <div
                  className={`wrapper ${
                    state.editForm.errorList.remarks ? 'has-error' : ''
                  }`}
                >
                  <textarea
                    name='content'
                    className='textarea'
                    maxLength={30}
                    value={state.editForm.remarks}
                    onChange={e => setRemarks(e.target.value)}
                  />
                  {state.editForm.errorList.remarks && (
                    <div className='error-message'>
                      {state.editForm.errorList.remarks}
                    </div>
                  )}
                </div>
              </div>
            </li>
            {state.editForm.workerType === ENTRANCE_WORKER_TYPES.worker.id && (
              <React.Fragment>
                <li className='form-list__item'>
                  <div className='job-category__label'>
                    <span className='label'>{data.editDialog.jobCategory}</span>
                  </div>
                  <div className='job-category__element'>
                    {isNullOrUndefinedOrEmptyStr(
                      state.editForm.categoryMajorName
                    ) === false &&
                      isNullOrUndefinedOrEmptyStr(
                        state.editForm.categoryMinorName
                      ) === false && (
                        <React.Fragment>
                          {state.editForm.categoryMajorName}
                          <span className='hyphen'>-</span>
                          {state.editForm.categoryMinorName}
                        </React.Fragment>
                      )}
                  </div>
                </li>
                <li className='form-list__item'>
                  <div className='position__label'>
                    <span className='label'>{data.editDialog.position}</span>
                  </div>
                  <div className='position__element'>
                    {state.editForm.positionName}
                  </div>
                </li>
                <li className='form-list__item'>
                  <div className='work-content__label'>
                    <span className='label'>{data.editDialog.workContent}</span>
                  </div>
                  <div className='work-content__element'>
                    <span>{state.editForm.workContent}</span>
                  </div>
                </li>
              </React.Fragment>
            )}
            <li className='form-list__item'>
              <div className='manual-update-user__label'>
                <span className='label'>
                  {data.editDialog.manualUpdateUser}
                </span>
              </div>
              <div className='manual-update-user__element'>
                <span>{state.editForm.manualUpdateUser}</span>
              </div>
            </li>
            <li className='form-list__item'>
              <div className='manual-update-at__label'>
                <span className='label'>{data.editDialog.manualUpdateAt}</span>
              </div>
              <div className='manual-update-at__element'>
                <span>{state.editForm.manualUpdateAt}</span>
              </div>
            </li>
          </ul>
        </React.Fragment>
      )}
    </InOutResultContext.Consumer>
  );
};

const getCcusSentNameById = id => {
  const status = _.find(CCUS_SENT_STATUS, { id });
  return status ? status.name : '';
};

const WithTooltip = ({ children, className }) => {
  // BLDE_V2-46523 iPadの場合はツールチップ不要
  if (isIPad()) {
    return children;
  } else {
    return (
      <Tippy
        duration={10}
        distance={24}
        arrowType='sharp'
        delay={[100, 0]}
        placement='bottom'
        followCursor={true}
        html={<div className={Styles.toopTip}>{children}</div>}
      >
        <p className={className}>{children}</p>
      </Tippy>
    );
  }
};

// 定数
const data = {
  tableTitles: [
    { name: 'approved', label: '承認', skipSort: true },
    { name: 'worker_type', label: '入退場者種別' },
    { name: 'company_name_1', label: '会社名' },
    { name: 'worker_name', label: '氏名' },
    { name: 'target_date', label: '出勤日' },
    { name: 'in', label: '入場時刻' },
    { name: 'out', label: '退場時刻' },
    { name: 'body_temperature_tag', label: '', skipSort: true },
    { name: 'body_temperature', label: '体温' },
    { name: 'ccus_send_status', label: 'CCUS送信' },
    { name: 'remarks', label: '備考' },
    { name: 'job_category', label: '職種' },
    { name: 'position_code', label: '立場' },
    { name: 'check_in_out_field_area_name', label: '打刻エリア' },
    {
      name: 'check_in_out_record_type_name',
      label: '打刻方法',
      skipSort: true,
    },
  ],
  buttonTitle: {
    worker_search: '作業員選択',
  },
  editDialog: {
    title: '入退場実績更新',
    back: '戻る',
    edit: '更新',
    subcontractor: '協力会社',
    companyName: '会社名',
    workerName: '入退場者名',
    workerNameSelect: '作業員選択',
    workerType: '入退場者種別',
    fieldTree: '現場体制',
    recordingMethod: '記録方法',
    attendanceDate: '出勤日',
    inTime: '入場時刻',
    outTime: '退場時刻',
    nextDay: '日跨ぎ',
    bodyTemperature: '体温（機器測定）',
    manualBodyTemperature: '体温（手入力）',
    remarks: '備考',
    manualUpdateUser: '編集ユーザー',
    manualUpdateAt: '更新日時',
    jobCategory: '職種',
    position: '立場',
    workContent: '作業内容',
  },
  date: {
    year: 0,
    month: 0,
    day: 0,
  },
  dateColon: '：',
  placeholder: {
    attendanceDate: '（例）2020/01/01',
    jobCategory: '職種を選択',
    position: '立場を選択',
  },
  jobCategoryLabel: {
    large: '大分類',
    small: '小分類',
  },
  manualBodyTemperatureTag: '手入力',
  checkInOutRecordTypeLabel: {
    in: '入：',
    out: '退：',
  },
};



// WEBPACK FOOTER //
// ./src/components/tables/InOutResultTable.jsx